import React from 'react';
import { DocumentDetails } from 'src/state/slice/models/CommonTypes';
import { FileDownload } from './FileDownloadBox';
import styled from 'styled-components';

interface IFileDownloadList {
  attachments: Array<DocumentDetails> | undefined;
  header?: React.ReactNode;
}
const FileDownloadContainer = styled.div`
  font-size: ${({ theme }) => theme.fontSize.s};
  margin-bottom: 0.5rem;
`;

export const FileDownloadList = ({
  attachments,
  header,
}: IFileDownloadList) => {
  if (attachments && attachments.length > 0)
    return (
      <>
        {header}
        {attachments &&
          attachments.map((item, i) => (
            <FileDownloadContainer key={i}>
              <FileDownload
                documentId={item.documentId}
                documentName={item.documentName}
              />
            </FileDownloadContainer>
          ))}
      </>
    );
  else return null;
};
